import { logError } from "utils/logger";

export type recaptchaResponseObject = {
    success: boolean;
    token?: string;
};

export default function fetchRecaptchaToken(): Promise<recaptchaResponseObject> {
    return new Promise((resolve, reject) => {
        window.grecaptcha.enterprise.ready(async () => {
            try {
                const recaptchaToken = await window.grecaptcha.enterprise.execute(
                    `${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`,
                    {
                        action: "homepage",
                    }
                );
                resolve({ success: true, token: recaptchaToken });
            } catch (error) {
                const errorMessage = (error as Error).message;
                logError("Could not fetch recaptchaToken", errorMessage);
                reject({ success: false });
            }
        });
    });
}
